var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product
    ? _c("div", { staticClass: "product-overlay" }, [
        _c("div", { staticClass: "product-overlay__top" }, [
          _c(
            "div",
            { staticClass: "product-overlay__info" },
            [
              _c("ProductRating", {
                staticClass: "product-overlay__rating",
                attrs: { rating: _vm.product.averageRatings }
              }),
              _vm._v(" "),
              _c("h2", {
                staticClass: "product-overlay__name",
                domProps: { innerHTML: _vm._s(_vm.product.name) }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "product-overlay__description",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.product.description || _vm.product.shortDescription
                  )
                }
              }),
              _vm._v(" "),
              _vm.availableVariants.length > 1
                ? _c("div", { staticClass: "products__item-variants" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedVariant,
                            expression: "selectedVariant"
                          }
                        ],
                        staticClass: "products__item-variants-select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedVariant = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.availableVariants, function(variant, index) {
                        return _c("option", {
                          key: variant.code,
                          domProps: {
                            value: index,
                            innerHTML: _vm._s(variant.name)
                          }
                        })
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.variant &&
              (_vm.price || !_vm.product.isConfigurable || _vm.priceReduction)
                ? _c(
                    "div",
                    { staticClass: "products__item-price" },
                    [
                      _vm.originalPrice
                        ? _c("strike", {
                            staticClass: "products__item-price-old",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.fwgpricecent(
                                  _vm.originalPrice,
                                  "short"
                                )
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "products__item-price-current",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$options.filters.fwgpricecent(
                              _vm.price,
                              "short"
                            )
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm.co2Compensation
                        ? _c("div", {
                            staticClass: "products__item-price-co2",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("shoplist.product.co2Compensation", {
                                  amount: _vm.$options.filters.fwgpricecent(
                                    _vm.co2Compensation,
                                    "short"
                                  )
                                })
                              )
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.priceReduction
                ? _c("div", {
                    staticClass: "products__item-price-reduction",
                    domProps: { innerHTML: _vm._s(_vm.priceReduction) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.variant &&
              _vm.isShop &&
              _vm.hasBasket &&
              !_vm.publicMode &&
              !_vm.menuMode &&
              !_vm.disabled
                ? [
                    !_vm.product.isEditable
                      ? _c("QuantityCounter", {
                          attrs: {
                            quantity: _vm.quantity,
                            "base-class": "products__item-quantity"
                          },
                          on: {
                            sub: function($event) {
                              return _vm.onSub()
                            },
                            add: function($event) {
                              return _vm.onAdd()
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "products__item-cart" },
                      [
                        _c("div", {
                          ref: "message",
                          staticClass: "products__item-cart-message",
                          class: {
                            "products__item-cart-message--added":
                              _vm.addedToCart
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("shoplist.product.successCart")
                            )
                          },
                          on: { click: _vm.onCloseMessage }
                        }),
                        _vm._v(" "),
                        _vm.product.isConfigurable
                          ? _c("Button", {
                              staticClass: "products__item-configure-button",
                              attrs: {
                                level: "outline",
                                type: "button",
                                text: _vm.$t("shoplist.product.configButton"),
                                disabled: _vm.locked,
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.onConfig()
                                }
                              }
                            })
                          : _c("Button", {
                              staticClass: "products__item-configure-button",
                              attrs: {
                                level: "outline",
                                type: "button",
                                text: _vm.$t("shoplist.product.cartButton"),
                                disabled: _vm.locked,
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.onCart()
                                }
                              }
                            })
                      ],
                      1
                    )
                  ]
                : _vm.isShop &&
                  (!_vm.hasBasket || _vm.publicMode) &&
                  !_vm.menuMode &&
                  !_vm.disabled
                ? [
                    _c(
                      "div",
                      { staticClass: "products__item-cart" },
                      [
                        _c("Button", {
                          staticClass: "products__item-public-button",
                          attrs: {
                            level: "outline",
                            type: "button",
                            text: _vm.$t("shoplist.product.startOrder"),
                            small: ""
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit("orderbox")
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                : !_vm.isShop && !_vm.menuMode && !_vm.disabled
                ? _c(
                    "div",
                    [
                      _c("Button", {
                        staticClass: "product-overlay__shop-button",
                        attrs: {
                          level: "outline",
                          type: "button",
                          text: _vm.$t("shoplist.product.shopButton"),
                          small: ""
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$emit("shop")
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "product-overlay__image" }, [
            _c("figure", { staticClass: "product-overlay__image-wrapper" }, [
              _c("img", {
                staticClass: "product-overlay__image-element",
                attrs: { src: _vm.product.image, loading: "lazy" }
              })
            ]),
            _vm._v(" "),
            _vm.productLabelText
              ? _c("img", {
                  staticClass: "product-overlay__image-label",
                  attrs: { src: _vm.productLabelText, loading: "lazy" }
                })
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "product-overlay__tabs" }, [
          _c("button", {
            staticClass: "product-overlay__tab",
            class: {
              "product-overlay__tab--active": _vm.activeTab == "nutrition"
            },
            attrs: { type: "button" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("shoplist.product.details.nutrition"))
            },
            on: {
              click: function($event) {
                return _vm.changeActiveTab("nutrition")
              }
            }
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "product-overlay__tab",
            class: {
              "product-overlay__tab--active": _vm.activeTab == "ratings"
            },
            attrs: { type: "button" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("shoplist.product.details.ratings.tab"))
            },
            on: {
              click: function($event) {
                return _vm.changeActiveTab("ratings")
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.activeTab == "nutrition"
          ? _c("div", { staticClass: "product-overlay__tab-content" }, [
              _vm.hasFeature("FEATURE_NUTRITION_DETAILS") &&
              (_vm.hasFeature("FEATURE_NUTRITION_DETAILS_ALLERGENS") ||
                _vm.hasFeature("FEATURE_NUTRITION_DETAILS_NUTRITION") ||
                _vm.hasFeature("FEATURE_NUTRITION_DETAILS_CO2") ||
                _vm.hasFeature("FEATURE_NUTRITION_DETAILS_TASTES")) &&
              (_vm.variantNutrients ||
                _vm.showCo2 ||
                _vm.variantAllergens ||
                _vm.variantTastes)
                ? _c("div", { staticClass: "product-overlay__details" }, [
                    (_vm.hasFeature("FEATURE_NUTRITION_DETAILS_NUTRITION") ||
                      _vm.hasFeature("FEATURE_NUTRITION_DETAILS_CO2")) &&
                    (_vm.variantNutrients || _vm.showCo2)
                      ? _c(
                          "div",
                          { staticClass: "product-overlay__details-wrapper" },
                          [
                            _vm.hasFeature(
                              "FEATURE_NUTRITION_DETAILS_NUTRITION"
                            ) && _vm.variantNutrients
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "product-overlay__details-block"
                                  },
                                  [
                                    _c("h3", {
                                      staticClass:
                                        "product-overlay__details-title",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "shoplist.product.details.nutrition"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "product-overlay__details-table"
                                      },
                                      _vm._l(_vm.variantNutrients, function(
                                        nutrient
                                      ) {
                                        return _c(
                                          "tr",
                                          {
                                            key: nutrient.key,
                                            staticClass:
                                              "product-overlay__details-table-row"
                                          },
                                          [
                                            _c("th", {
                                              staticClass:
                                                "product-overlay__details-table-cell",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  nutrient.label
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("td", {
                                              staticClass:
                                                "product-overlay__details-table-cell",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  nutrient.value
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasFeature("FEATURE_NUTRITION_DETAILS_CO2") &&
                            _vm.showCo2
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "product-overlay__details-block"
                                  },
                                  [
                                    _c("h3", {
                                      staticClass:
                                        "product-overlay__details-title",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "shoplist.product.details.co2.title"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.variantDetails.co2.emission > 0
                                      ? _c(
                                          "table",
                                          {
                                            staticClass:
                                              "product-overlay__details-table"
                                          },
                                          [
                                            _c(
                                              "tr",
                                              {
                                                staticClass:
                                                  "product-overlay__details-table-row"
                                              },
                                              [
                                                _c("th", {
                                                  staticClass:
                                                    "product-overlay__details-table-cell",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "shoplist.product.details.co2.emissionLabel"
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("td", {
                                                  staticClass:
                                                    "product-overlay__details-table-cell",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "shoplist.product.details.co2.emissionValue",
                                                        {
                                                          value:
                                                            _vm.variantDetails
                                                              .co2.emission
                                                        }
                                                      )
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.variantDetails.co2.percent > 0
                                      ? _c("span", {
                                          staticClass:
                                            "product-overlay__details-table-cell product-overlay__details-table-cell--small",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "shoplist.product.details.co2.percentValue",
                                                {
                                                  value:
                                                    _vm.variantDetails.co2
                                                      .percent
                                                }
                                              )
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.hasFeature("FEATURE_NUTRITION_DETAILS_ALLERGENS") ||
                      _vm.hasFeature("FEATURE_NUTRITION_DETAILS_TASTES")) &&
                    (_vm.variantAllergens || _vm.variantTastes)
                      ? _c(
                          "div",
                          { staticClass: "product-overlay__details-wrapper" },
                          [
                            _vm.hasFeature(
                              "FEATURE_NUTRITION_DETAILS_ALLERGENS"
                            ) && _vm.variantAllergens
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "product-overlay__details-block"
                                  },
                                  [
                                    _c("h3", {
                                      staticClass:
                                        "product-overlay__details-title",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "shoplist.product.details.allergens.title"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "product-overlay__details-allergens"
                                      },
                                      _vm._l(_vm.variantAllergens, function(
                                        allergen
                                      ) {
                                        return _c(
                                          "li",
                                          {
                                            key: allergen.key,
                                            staticClass:
                                              "product-overlay__details-allergen"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "product-overlay__details-allergen-icon"
                                              },
                                              [
                                                _c(allergen.icon, {
                                                  tag: "component"
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass:
                                                "product-overlay__details-allergen-label",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  allergen.label
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasFeature(
                              "FEATURE_NUTRITION_DETAILS_TASTES"
                            ) && _vm.variantTastes
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "product-overlay__details-block"
                                  },
                                  [
                                    _c("h3", {
                                      staticClass:
                                        "product-overlay__details-title",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "shoplist.product.details.taste.title"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "product-overlay__details-tastes"
                                      },
                                      _vm._l(_vm.variantTastes, function(
                                        taste
                                      ) {
                                        return _c("li", {
                                          key: taste.key,
                                          staticClass:
                                            "product-overlay__details-taste",
                                          domProps: {
                                            innerHTML: _vm._s(taste.label)
                                          }
                                        })
                                      }),
                                      0
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "product-overlay__details" }, [
                    _c(
                      "div",
                      { staticClass: "product-overlay__details-wrapper" },
                      [
                        _c(
                          "div",
                          { staticClass: "product-overlay__details-block" },
                          [
                            _c("h3", {
                              staticClass: "product-overlay__details-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "shoplist.product.details.allergens.title"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "product-overlay__info-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.fwgcmstext(
                                    _vm.$te("shoplist.product.tempNutrition")
                                      ? _vm.$t("shoplist.product.tempNutrition")
                                      : _vm.product.nutritionInfos || "-"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.activeTab == "ratings"
          ? _c("div", { staticClass: "product-overlay__tab-content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "product-overlay__details product-overlay__details--reviews"
                },
                [
                  _c("div", { staticClass: "product-overlay__details-block" }, [
                    _c(
                      "h3",
                      { staticClass: "product-overlay__details-title" },
                      [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("shoplist.product.details.ratings.title")
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              "&nbsp;(" + _vm.ratingsCount + ")"
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("ProductRating", {
                          staticClass: "product-overlay__details-title-rating",
                          attrs: { rating: _vm.product.averageRatings }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.currentProductReviews.reviews &&
                    _vm.currentProductReviews.reviews.length
                      ? _c(
                          "ul",
                          { staticClass: "product-overlay__reviews" },
                          _vm._l(_vm.currentProductReviews.reviews, function(
                            review
                          ) {
                            return _c(
                              "li",
                              {
                                key: "product-review-" + review.id,
                                staticClass: "product-overlay__review"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "product-overlay__review-name"
                                  },
                                  [
                                    _c("strong", {
                                      directives: [
                                        {
                                          name: "sanitize",
                                          rawName: "v-sanitize",
                                          value: review.date,
                                          expression: "review.date"
                                        }
                                      ]
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      directives: [
                                        {
                                          name: "sanitize",
                                          rawName: "v-sanitize",
                                          value: review.title,
                                          expression: "review.title"
                                        }
                                      ]
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c("ProductRating", {
                                  staticClass:
                                    "product-overlay__review-name-rating",
                                  attrs: { rating: review.rating }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  directives: [
                                    {
                                      name: "sanitize",
                                      rawName: "v-sanitize",
                                      value: review.comment,
                                      expression: "review.comment"
                                    }
                                  ],
                                  staticClass: "product-overlay__review-comment"
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _c("div", {
                          staticClass: "product-overlay__no-reviews",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("shoplist.product.details.ratings.empty")
                            )
                          }
                        })
                  ]),
                  _vm._v(" "),
                  !_vm.menuMode
                    ? _c(
                        "div",
                        { staticClass: "product-overlay__details-block" },
                        [
                          _c("h3", {
                            staticClass: "product-overlay__details-title",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "shoplist.product.details.ratings.formTitle"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("ProductReviewForm", { attrs: { code: _vm.code } })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }